/** @jsxImportSource @emotion/react */
import * as React from 'react'
import { Box, CircularProgress } from '@mui/material'
import { Banner } from '@app/components/Guide/ui/Banner'
import { Section } from '@app/components/Guide/ui/Section'
import { useFetchGlossaryPage } from '@app/components/Guide/hooks/useFetchGlossaryPage'
import GlossaryContent from '@app/components/Guide/ui/GlossaryContent'
import { CenteredBox } from '@app/components/ui/CenteredBox/CenteredBox'

export const GlossaryPage = () => {
  const { data: glossaryPage, isLoading: isPageLoading, error: pageError } = useFetchGlossaryPage()

  if (isPageLoading) {
    return (
      <CenteredBox>
        <CircularProgress />
      </CenteredBox>
    )
  }

  if (pageError) {
    return <CenteredBox>Error loading glossary</CenteredBox>
  }

  const title = glossaryPage?.title ?? 'Glossary'
  const introduction = glossaryPage?.description ?? ''

  return (
    <Box sx={{ minHeight: '100%', display: 'flex', flexDirection: 'column' }}>
      <Banner header={title} subheader={introduction} />

      <Section sx={{ flexGrow: 1 }}>
        <GlossaryContent />
      </Section>
    </Box>
  )
}

export default GlossaryPage
